import { render, staticRenderFns } from "./Validations.vue?vue&type=template&id=0b90c1d0&"
import script from "./Validations.vue?vue&type=script&lang=js&"
export * from "./Validations.vue?vue&type=script&lang=js&"
import style0 from "./Validations.vue?vue&type=style&index=0&id=0b90c1d0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b90c1d0')) {
      api.createRecord('0b90c1d0', component.options)
    } else {
      api.reload('0b90c1d0', component.options)
    }
    module.hot.accept("./Validations.vue?vue&type=template&id=0b90c1d0&", function () {
      api.rerender('0b90c1d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Validations.vue"
export default component.exports